import React from "react";
import { Link } from "react-router";

function getLinkClassName(location, url, isAccurate = false) {
  //console.log(url)

  const { pathname } = location;
  let isActive = false;

  if (
    pathname.length >= url.length &&
    isAccurate === false &&
    pathname.substr(0, url.length) === url
  ) {
    isActive = true;
  }

  if (isAccurate === true && pathname === url) {
    isActive = true;
  }
  //console.log(isActive)
  return isActive === true ? "active" : null;
}

class DecisionsWrapper extends React.Component {
  render() {
    let { location, breadcrumbsTitle, position } = this.props;

    return (
      <div style={{ padding: "50px" }}>
        <div className="breadcrumbs">
          Home&nbsp;&nbsp;>&nbsp;&nbsp;Decisions&nbsp;&nbsp;>&nbsp;&nbsp;
          <b style={{ textTransform: "capitalize" }}>
            {breadcrumbsTitle.split("/")[2].indexOf("teamoverview") > -1
              ? breadcrumbsTitle
                  .split("/")[2]
                  .split(/(?=.{8}$)/)
                  .join(" ")
              : breadcrumbsTitle.split("/")[2]}
          </b>
        </div>
        <div className="clearfix" style={{ maxHeight: "300px" }}>
          <div
            className="decisions-menu"
            style={{ border: "1px solid #DADADA", marginTop: "20px" }}
          >
            <Link
              to="/decisions/teamoverview"
              className={getLinkClassName(location, "/decisions/teamoverview")}
            >
              Team Overview
            </Link>
            <hr />
            <Link
              to={
                position !== undefined
                  ? `/decisions/${position.toString()}`
                  : null
              }
              className={
                position !== undefined
                  ? getLinkClassName(
                      location,
                      "/decisions/" + position.toString()
                    )
                  : null
              }
            >
              {position.toUpperCase()}
            </Link>
            <hr />
            <Link
              to="/decisions/product-development"
              className={getLinkClassName(
                location,
                "/decisions/product-development"
              )}
            >
              Head of Product
            </Link>
            <hr />
            <Link
              to="/decisions/product-marketing"
              className={getLinkClassName(
                location,
                "/decisions/product-marketing"
              )}
            >
              Head of Marketing
            </Link>
            <hr />
            <Link
              to="/decisions/operations"
              className={getLinkClassName(location, "/decisions/operations")}
            >
              Head of Operations
            </Link>
            <hr />
            <Link
              to="/decisions/finance"
              className={getLinkClassName(location, "/decisions/finance")}
            >
              Head of Finance
            </Link>
            <hr />
          </div>
        </div>
      </div>
    );
  }
}

export default DecisionsWrapper;



// WEBPACK FOOTER //
// ./src/components/decisions/wrapper.js